//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListOneGameGallery = () => async (dispatch) => {
    try {
        const video = await apis.get('one_game_gallery', `/list`);
        if (Array.isArray(video)) {
            await dispatch(Actions.listOneGameGallery(video));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing one game gallery',
                error,
                module: 'ONE_GAME_GALLERY',
                operation: 'LIST_ORGANIZATION_GROUP_GROUP'
            })
        }
    }
};

export const handleCreateOneGameGallery = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('one_game_gallery', `/create`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOneGameGallery(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one game gallery',
                error,
                module: 'ONE_GAME_GALLERY',
                operation: 'CREATE_ORGANIZATION_GROUP_GROUP'
            })
        }
    }
};

export const handleDeleteOneGameGallery = (id) => async (dispatch) => {
    try {
        const videos = await apis.del('one_game_gallery', `/delete/${id}`);
        if (videos?.length > 0) {
            await dispatch(Actions.deleteOneGameGallery(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting one game gallery',
                error,
                module: 'ONE_GAME_GALLERY',
                operation: 'DELETE_ORGANIZATION_GROUP_GROUP'
            })
        }
    }
};

export const handleDeleteCategoryGallery = (id) => async (dispatch) => {
    try {
        const videos = await apis.del('one_game_gallery', `/deleteCategoryImage/${id}`);
        if (videos?.length > 0) {
            await dispatch(Actions.deleteOneGameGallery(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting category gallery',
                error,
                module: 'ONE_GAME_GALLERY',
                operation: 'DELETE_CLASS_GROUP'
            })
        }
    }
};
